/* eslint-disable camelcase */
import type { FC } from 'react'
import type { Content } from '@prismicio/client'
import type { SliceComponentProps } from '@prismicio/react'
import styles from './SubsDetailTextSlider.module.scss'

/**
 * Props for `SubsDetailTextSlider`.
 */
export type SubsDetailTextSliderProps = SliceComponentProps<Content.SubsDetailTextSliderSlice>

/**
 * Component for "SubsDetailTextSlider" Slices.
 */
// eslint-disable-next-line react/function-component-definition, arrow-body-style
const SubsDetailTextSlider: FC<SubsDetailTextSliderProps> = ({ slice }) => {
	const { primary, items } = slice
	const color = primary.slider_color || '#000000'
	const speed = Number(primary.slider_speed) || 5
	const heightDesktop = primary.slider_height_desktop || 100
	const heightMobile = primary.slider_height_mobile || 80
	const texts = (items as { slider_text?: string }[])
		.map((item) => item.slider_text)
		.filter(Boolean) as string[]

	// Duplicate texts for seamless infinite scroll
	const repeatedTexts = [...texts, ...texts]

	// Simple duration calculation: higher speed = faster animation (lower duration)
	const duration = Math.max(120 / speed, 10) // Minimum 10s, maximum 120s

	// Only override height if not default
	const styleOverrides: React.CSSProperties & { [key: string]: string | number } = {}
	// if (heightMobile !== 80) {
	styleOverrides.height = `${heightMobile}px`
	styleOverrides['--sdt-slider-mobile-height'] = `${heightMobile}px`
	styleOverrides['--sdt-slider-font-size'] = `${heightMobile * 0.4}px`
	// }
	// if (heightDesktop !== 100) {
	styleOverrides['--sdt-slider-desktop-height'] = `${heightDesktop}px`
	styleOverrides['--sdt-slider-desktop-font-size'] = `${heightDesktop * 0.4}px`
	// }

	// Set animation duration
	styleOverrides['--sdt-slider-duration'] = `${duration}s`

	return (
		<section
			data-slice-type={slice.slice_type}
			data-slice-variation={slice.variation}
			style={{ width: '100vw', background: color, overflow: 'hidden', position: 'relative' }}
		>
			<div className={styles['sdt-slider']} style={styleOverrides}>
				{repeatedTexts.map((text, i) => (
					<span key={`${text}-${i % texts.length}`}>
						{text}
						{i < repeatedTexts.length - 1 && <span style={{ margin: '0 1.5rem' }}>·</span>}
					</span>
				))}
			</div>
		</section>
	)
}

export default SubsDetailTextSlider
